import { render } from "./baseTableView.vue?vue&type=template&id=db2f3a3a&scoped=true"
import script from "./baseTableView.vue?vue&type=script&lang=js"
export * from "./baseTableView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db2f3a3a"]])

export default __exports__